import { GetStaticProps } from 'next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import Head from 'next/head';
import { useLayoutEffect } from 'react';

import { FAQBlock } from '../components/landingV4/FAQBlock';
import { FeedbackBlock } from '../components/landingV4/FeedbackBlock';
import { Footer } from '../components/landingV4/Footer';
import { Header } from '../components/landingV4/Header';
import { IntegrationsHero } from '../components/landingV4/IntegrationsHero';
import { IntegrationsMatchCtaBlock } from '../components/landingV4/IntegrationsMatchCtaBlock';
import { IntegrationsMethodSpecsBlock } from '../components/landingV4/IntegrationsMethodSpecsBlock';
import { IntegrationsScenariosBlock } from '../components/landingV4/IntegrationsScenariosBlock';
import { SnackbarProvider } from '../components/landingV4/SnackbarProvider';
import { EmptyLayout } from '../components/layout/MainLayout/EmptyLayout';

import { NextPageWithLayout } from './_app';

const Page: NextPageWithLayout = () => {
  useLayoutEffect(() => {
    document.documentElement.classList.add('v4');
    document.documentElement.style.setProperty('--background', '#09090B');

    return () => {
      document.documentElement.classList.remove('v4');
      document.documentElement.style.removeProperty('--background');
    };
  }, []);

  return (
    <SnackbarProvider>
      <Head>
        <title>Integrations | SmartGates</title>
        <meta
          name="description"
          content="Ready-to-use payment integrations: 100+ scenarios, PCI DSS compliant infrastructure, and fast setup for global pay-ins and mass pay-outs."
        />
      </Head>

      <Header />
      <IntegrationsHero />
      <IntegrationsScenariosBlock />
      <IntegrationsMethodSpecsBlock />
      <IntegrationsMatchCtaBlock />
      <FAQBlock />
      <FeedbackBlock />
      <Footer />
    </SnackbarProvider>
  );
};

Page.getLayout = (page) => <EmptyLayout withFloatMenu={false}>{page}</EmptyLayout>;

export const getStaticProps: GetStaticProps = async ({ locale }) => {
  return {
    props: {
      ...(await serverSideTranslations(locale ?? 'en', ['common'])),
    },
  };
};

export default Page;
